<template>
  <v-card min-height="640" class="mt-6">
    <v-card-title>
      Tipo de Documentos
      <v-spacer></v-spacer>
      <v-container>
        <v-row>
          <v-col cols="8">
            <document-type-create />
          </v-col>
          <v-col cols="4" class="text-right">
            <v-text-field
              v-model="search"
              :append-icon="icon.search"
              id="document_type_table__buscar__text"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-data-table
      :headers="documentTypeHeaders"
      :items="documentsType"
      :loading="loading"
      :loading-text="documentsTypeLoadingText"
      :no-data-text="documentsTypeNoDataText"
      :items-per-page="25"
      :show-current-page="true"
      :search="search"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, -1]
      }"
    >
      <template class="text-right" v-slot:item.actions="{ item }">
        <document-type-update
          :id="`documet_type_table__actualizar__list` + item.clave"
          v-model="item"
        ></document-type-update>

        <document-type-delete
          :id="`documet_type_table__eliminar__list` + item.clave"
          v-model="item"
        ></document-type-delete>

        <document-type-visibility
          :id="`documet_type_table__ocultar__list` + item.clave"
          v-model="item"
        ></document-type-visibility>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mdiMagnify } from '@mdi/js'
import { pushNotification, messageErrorResponse } from '@/store/helpers'
import {
  documentTypeStoreData,
  documentTypeStoreActions
} from '../store/documentTypeStoreHelpers'

import DocumentTypeCreate from '@/modules/catalogs/components/DocumentTypeCreate'
import DocumentTypeUpdate from '@/modules/catalogs/components/DocumentTypeUpdate'
import DocumentTypeDelete from '@/modules/catalogs/components/DocumentTypeDelete'
import DocumentTypeVisibility from '@/modules/catalogs/components/DocumentTypeVisibility'

export default {
  name: 'DocumentTypeTable',
  components: {
    DocumentTypeCreate,
    DocumentTypeUpdate,
    DocumentTypeDelete,
    DocumentTypeVisibility
  },
  data() {
    return {
      icon: {
        search: mdiMagnify
      },
      search: '',
      loading: false
    }
  },
  created() {
    this.loading = true

    this.getDocumentsType()
      .catch(err => {
        this.notificationError(err)
      })
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    ...documentTypeStoreData
  },
  methods: {
    ...documentTypeStoreActions,
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgDocumentTypeServiceError,
        'error',
        'left',
        false,
        false
      )
    }
  }
}
</script>
